__turbopack_context__.v({
  "className": "euclidcircularbregular_3dc43616-module__7kFcSq__className",
});
